﻿(function (angular, ToyotaForms) {
  "use strict";

  angular
    .module("Toyota.Factories")
    .factory("Addresses", [
      "$q",
      "$filter",
      "API",
      function ($q, $filter, API) {
        return function (search) {

          var searchTerm = search.trim();

          if (!searchTerm) {
            return $q.when();
          }

          var url = $filter("formatArgs")(ToyotaForms.API.Address.AutoComplete.CustomerAddressByAddress, [encodeURIComponent(searchTerm)]);

          var deferred = $q.defer();

          API.get(url).then(
            function (req) {
              deferred.resolve(req.data.results);
            },
            function () {
              deferred.resolve([]);
            }
          );

          return deferred.promise;
        };
      },
    ])
    .factory("AddressById", [
      "$q",
      "$filter",
      "API",
      function ($q, $filter, API) {
        return function (id) {
          var url = $filter("formatArgs")(ToyotaForms.API.Address.ById, [id]);

          var deferred = $q.defer();

          API.get(url).then(
            function (req) {
              deferred.resolve(req.data.result);
            },
            function () {
              deferred.resolve([]);
            }
          );

          return deferred.promise;
        };
      },
    ]);
})(window.angular, window.ToyotaForms);
